import React, { useContext } from 'react';
import { ThemeProvider } from 'styled-components';
import { TagProps } from './types';
import { TagContainer, TagIconWrapper } from './styles';
import { ThemeContext } from '../ThemeProvider/ThemeProvider';
import { validateNonEmptyString } from '../utils/validationUtils';

const Tag: React.FC<TagProps> = (props) => {
  const {
    hierarchy = 'standard',
    status = 'default',
    label,
    testId,
    fullWidth = false,
    icon,
  } = props;

  const { actualTheme } = useContext(ThemeContext);

  validateNonEmptyString(label, 'label', 'Tag');

  if (hierarchy === 'highlight' && (icon === undefined || icon === null)) {
    throw new Error('Tag: la jerarquía "highlight" requiere la prop "icon".');
  }

  return (
    <ThemeProvider theme={actualTheme}>
      <TagContainer
        data-testid={testId}
        hierarchy={hierarchy}
        status={status}
        fullWidth={fullWidth}
        hasIcon={!!icon}
      >
        {icon && <TagIconWrapper>{icon}</TagIconWrapper>}
        {label}
      </TagContainer>
    </ThemeProvider>
  );
};

export default Tag;
